export function is_date(input) {
    if ( Object.prototype.toString.call(input) === "[object Date]" ) {
      return true;
    }
    return false;
}